export default __webpack_public_path__ + "locales/zh-CN/DeleteProfileEverDialog.json?hash=55b8f589ae14b7609d9c42bcfc2ed0f4";